import { formatDateProgram } from '@/utils/formatDate';

import type { ISODateString } from '@/types/string';

export function createDateDurationString(startDate: ISODateString, endDate: ISODateString): string {
  const startDay = formatDateProgram(startDate);
  const endDay = formatDateProgram(endDate);

  if (startDay === endDay) return startDay;
  return `${startDay} t/m ${endDay}`;
}
